export class MachineCopySettings {
  copyDataConfiguration: boolean = false;
  copyExternalUrlConfiguration: boolean = false;
  copyInlineFrameCockpitConfiguration: boolean = false;
  copyStatusIndicator: boolean = false;
  copyTableauConfiguration: boolean = false;
  copyTileConfiguration: boolean = false;
  copyTrafficLightConfiguration: boolean = false;

  get copy(): boolean {
    return this.copyDataConfiguration || this.copyExternalUrlConfiguration || this.copyInlineFrameCockpitConfiguration ||
        this.copyStatusIndicator || this.copyTableauConfiguration || this.copyTileConfiguration || this.copyTrafficLightConfiguration;
  }
}